import { SxProps } from "@mui/material";

export const actionBarButtonPrimaryLightStyle = (
  style: "text" | "contained"
): SxProps => ({
  maxHeight: "36px",
  borderRadius: "6px",
  ml: 1.5,
  px: "10px",
  py: "5px",
  color: "white",
  textTransform: "capitalize",
  borderColor: "#004e8f",
  background: "#2b5a94",
  border: "1px solid transparent",
  "&:hover": {
    background: style === "contained" ? "#004e8f" : "white",
    border: style === "text" ? "1px solid #004e8f" : "1px solid transparent"
  },
  "&:disabled": {
    color: style === "contained" ? "white" : "#004e8f",
    cursor: "none",
    opacity: 0.6
  }
});

export const actionBarButtonPrimaryDarkStyle = (
  style: "text" | "contained"
): SxProps => ({
  maxHeight: "36px",
  borderRadius: "6px",
  ml: 1.5,
  px: "10px",
  textTransform: "capitalize",
  py: "5px",
  color: style === "contained" ? "#000000" : "#fcfcfd",
  borderColor: style === "contained" ? "#FF9F09" : "#383838",
  background: style === "contained" ? "#FF9F09" : "#383838",
  border: "1px solid transparent",
  "&:hover": {
    background: style === "contained" ? "#e89008" : "transparent",
    border:
      style === "text" ? "1px solid rgb(41, 40, 40)" : "1px solid transparent",
    opacity: style === "contained" ? 1 : 0.8
  },
  "&:disabled": {
    opacity: 0.6,
    background: "#383838",
    color: "#fcfcfd"
  }
});
